import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import {AemDimension} from './AemDimension';
import {AemExtra2} from './AemExtra2';
import {HblInven} from './HblInven';
import {AeAcct, AeAcctRecord} from './AeAcctRecord';
import { FileLockProp, InvoiceBillCrdb } from '../ifmsTypes';
import {AeHbl} from './AeHbl';
import _ from 'lodash';
import { CrDbHd } from './CrDbHd';
import { appendLine } from '../util';
import { MblStatusViewModel } from './MblStatusViewModel';

interface AeMblNewEvent {
    check: boolean,
    date: string|null,
    location: string,
}

export class AeMbl extends TrackableEntity {
    modelName:string = "aembl"; //for ifmsButton > getChangedListData

    refNo: string = '';
    mawbNo: string = '';
    fltNo: string = '';
    by1: string = '';
    by2: string = '';
    iataCode: string = '';
    accountNo: string = '';
    commodity: string = '';
    carVal: string = '';
    cusVal: string = '';
    carrierSpotNo: string = '';
    bCurr: string = '';
    iataCurr: string = '';
    shipper: number = 0;
    agent: number = 0;
    carrier: number = 0;
    lCode: string = '';
    agentCreditHold: boolean = false;
    dCode: string = '';
    to1: string = '';
    to2: string = '';
    loadingPort: string = '';
    discharge: string = '';
    etd: string | null = null;
    etdDate: string | null = null;
    etdTime: string | null = null;
    eta: string | null = null;
    etaDate: string | null = null;
    etaTime: string | null = null;
    blDate: string | null = null;
    postDate: string | null = null;
    blType: string = '';
    blTypeCheck: boolean = false;
    ppCc: string = '';
    bKl: string = '';
    iataKl: string = '';
    kl: string = '';
    pkgs: number = 0;
    grossWeight: number = 0;
    lGrossWeight: number = 0;
    chgWeight: number = 0;
    lChgWeight: number = 0;
    iAmount: number = 0;
    bRate: number = 0;
    bAmount: number = 0;
    iataRate: number = 0;
    iataAmount: number = 0;
    fileClosed: number = 0;
    isFileClosed: boolean = false;
    closeDate: string | null = null;
    closedBy: string = '';
    accountClosed: number = 0;
    accountCloseDate: string | null = null;
    accountClosedBy: string = '';
    actClosed: boolean = false;
    actClosedBy: string = '';
    actCloseDate: string | null = null;
    handInfo: string = '';
    accountInfo: string = '';
    mark: string = '';
    description: string = '';
    otherInfo: string = '';
    pWtChg: number = 0;
    cWtChg: number = 0;
    pValChg: number = 0;
    cValChg: number = 0;
    pTaxChg: number = 0;
    cTaxChg: number = 0;
    pAgtChg: number = 0;
    cAgtChg: number = 0;
    pCarChg: number = 0;
    cCarChg: number = 0;
    pTotal: number = 0;
    cTotal: number = 0;
    issuingCarrier: number = 0;
    branch: string = '';
    rateClass: string = '';
    cutOff: string | null = null;
    cutOffDate: string | null = null;
    cutOffTime: string | null = null;
    cur1: string = '';
    cur2: string = '';
    exRate1: number = 0;
    exRate2: number = 0;
    completeBill: boolean = false;
    completeInvo: boolean = false;
    completeCrDb: boolean = false;
    profitShare: number = 0;
    line: string = '';
    confirmDate: string | null = null;
    shipmentType: string = '';
    agent2: number = 0;
    agent3: number = 0;
    mSmanId: string = '';
    payableTo: number = 0;
    dutyCustomer: number = 0;
    dutyCustomerName: string = '';
    dutyAgent: number = 0;
    dutyAgentName: string = '';
    mblCustomer: number = 0;
    showCharge: boolean = false;
    pUnit: string = '';
    firstTo: string = '';
    sAddr: string = '';
    cAddr: string = '';
    nAddr: string = '';
    nAddr2: string = '';
    sci: string = '';
    notify: number = 0;
    notify2: number = 0;
    chkEdit: boolean = false;
    consignee: number = 0;
    etd1: string | null = null;
    etd2: string | null = null;
    agentName: string = '';
    issuingCarrierName: string = '';
    payableToName: string = '';
    dimension: AemDimension | null = null;
    shipperName: string = '';
    consigneeName: string = '';
    notifyPartyName: string = '';
    notifyParty2Name: string = '';
    mblCustomerName: string = '';
    carrierName: string = '';
    agent2Name: string = '';
    agent3Name: string = '';
    operator: string = '';
    descList: AemExtra2[] = [];
    invList: HblInven[] = [];
    acctList: AeAcct[] = [];
    id: number = 0;
    u1Id: string = '';
    u1Date: string | null = null;
    u2Id: string = '';
    u2Date: string | null = null;
    pimsLinkId: number = 0;
    pimsLinkDate: string | null = null;
    pimsLinkUserId: string = '';
    agentPimsId: number = 0;
    aaid: number = 0;
    abbr: string = '';
    hblCount: number = 0;
    confirmedBy: string = '';
    agentRefNo: string = '';
    volCm: boolean = false;
    mblCustomer2: number = 0;
    mblCustomer2Name: string = '';
    firstToName: string = '';
    statusInvo: string = '';
    statusBill: string = '';
    statusCrDb: string = '';
    isDomestic: boolean = false;
    projectNo: string = '';
    labelRemark: string = '';
    //airline status
    pickupDate: string | null = null;
    pickupLoc: string = '';
    atd: string | null = null;
    atdLoc: string = '';
    customsRls: string | null = null;
    customsRlsLoc: string = '';
    ata: string | null = null;
    ataLoc: string = '';
    delivery: string | null = null;
    delvLoc: string = '';
    deliveryBy: string = '';
    avail: string | null = null;
    availLoc: string = '';
    // not save
    AEFscRate: number  = 0;
    AESscRate: number  = 0;
    AEFscMin: number  = 0;
    AESscMin: number  = 0;
    byFSCGrossWT: boolean = false;
    bySSCGrossWT: boolean = false;
    AEFscAmount: number = 0;
    AESscAmount: number = 0;
    showCharged: string = '';
    showCharged0: boolean = false;
    showCharged1: boolean = false;
    showOther: string = '';
    showOther0: boolean = false;
    showOther1: boolean = false;
    showOtherAmt: string = '';
    showOtherAmt0: boolean = false;
    showOtherAmt1: boolean = false;
    showToBy: string = '';
    showToBy0: boolean = false;
    showToBy1: boolean = false;
    
    // Allow Partial for change tracking
    aeAcctData: Partial<AeAcctRecord> | null = null;
    
    hblList: AeHbl[] = [];
    
    milestone: MblStatusViewModel|null = null;

    //<save-sqlinfo: ISalesCostParent
    invoiceBill: InvoiceBillCrdb|null = null;
    readonlyCrdbLineItems?: Array<CrDbHd>|null = null;
    //save-sqlInfo>

    loadBillingsTabData:boolean = true;
    needJournalUpdate: boolean = false;

    //enableDirectBl:boolean = true;
    enableShipmentType:boolean = true;
    enableAgent:boolean = true;

    // new milestone timestamps - helpers for editing milestone (Dario)
    newEvents: Array<AeMblNewEvent> = [
        { check: false, date: null, location: '' },
        { check: false, date: null, location: '' },
        { check: false, date: null, location: '' },
        { check: false, date: null, location: '' },
        { check: false, date: null, location: '' },
        { check: false, date: null, location: '' },
    ];

    // events that have been interacted with
    toggledEvents: Array<number> = [];

    alreadyAskAboutFileLock: boolean = false;

    static fileLockEnableProps: FileLockProp[] = [
        { key: 'agent', name: 'MBL Agent 1' },
    ];

    get canChangeBranch():boolean {
        if (this.id <= 0) {
            return true;
        }

        const allowedStatuses = ['', 'E', 'D'];
        return allowedStatuses.includes(this.statusBill) &&
            allowedStatuses.includes(this.statusInvo) &&
            allowedStatuses.includes(this.statusCrDb) &&
            this.hblList.every(h => allowedStatuses.includes(h.statusBill) && allowedStatuses.includes(h.statusInvo) && allowedStatuses.includes(h.statusCrDb))
    };

    constructor(init?:Partial<AeMbl>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('dutyCustomerName', 'dutyAgentName', 'dimension', 'agent2Name', 'agent3Name', //'descList', 
        'id', 'hblCount', 'mblCustomer2Name', 'fistToPortName', 'toggledEvents', 'newEvents', 'invoiceBill', 'hblList', 
        'canChangeBranch', 'actClosed', 'actClosedBy', 'actCloseDate', 'milestone','AEFscRate','AESscRate','AEFscMin','AESscMin',
        'AEFscAmount','AESscAmount','byFSCGrossWT','bySSCGrossWT', 'confirmedBy', 'confirmDate', 'loadBillingsTabData', 'needJournalUpdate',
        'enableAgent', 'enableShipmentType', 'alreadyAskAboutFileLock'
        );
        this.getdateProps.push('u1Date', 'u2Date'); 
        if(this.id === 0) this.id = this.GetNextId();

        if(this.descList.length >0){
            this.descList = this.descList.map(d => new AemExtra2(d));
        } else {
            this.descList = [];
        }
        if(this.invList.length >0){
            this.invList = this.invList.map(d => new HblInven(d));
        } else {
            this.invList = [];
        }

        this.aeAcctData = new AeAcctRecord(init?.aeAcctData??{});
    }

    isFileLockFor(propName: string) {
        return this.fileClosed > 0 && !AeMbl.fileLockEnableProps.some(x => x.key === propName);
    }

    static getFileLockMessage(): string {
        const messageBase = appendLine("OP Closed", "The following fields are editable only:\n")
        return appendLine(messageBase, AeMbl.fileLockEnableProps
            .map(x => x.name)
            .reduce((acc: string, x) => appendLine(acc, `${x}`), ""));
    }
    
    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        const dicFieldMappings:IDictionary<DBMappingInfo> = {};
        _.keys(AeMbl.dicFieldMappings).forEach(m=>{
            dicFieldMappings[m] = AeMbl.dicFieldMappings[m];
        });

        _.keys(AemExtra2.dicFieldMapping).forEach(m=> {
            dicFieldMappings[`descList.${m}`] = AemExtra2.dicFieldMapping[m];
        });

        _.keys(HblInven.dicFieldMappings).forEach(m=> {
            dicFieldMappings[`invList.${m}`] = HblInven.dicFieldMappings[m];
        });

        _.keys(AeAcctRecord.dicFieldMappings).forEach(m=> {
            dicFieldMappings[`aeAcctData.${m}`] = AeAcctRecord.dicFieldMappings[m];
        });
        return dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_AOMMAIN' }),
        'refNo': new DBMappingInfo({ field: 'F_REFNO', table: 'T_AOMMAIN' }),
        'mawbNo': new DBMappingInfo({ field: 'F_MAWBNO', table: 'T_AOMMAIN' }),
        'fltNo': new DBMappingInfo({ field: 'F_FLTNO', table: 'T_AOMMAIN' }),
        'by1': new DBMappingInfo({ field: 'F_BY1', table: 'T_AOMMAIN' }),
        'by2': new DBMappingInfo({ field: 'F_BY2', table: 'T_AOMMAIN' }),
        'iataCode': new DBMappingInfo({ field: 'F_IATACODE', table: 'T_AOMMAIN' }),
        'accountNo': new DBMappingInfo({ field: 'F_ACCOUNTNO', table: 'T_AOMMAIN' }),
        'commodity': new DBMappingInfo({ field: 'F_COMMODITY', table: 'T_AOMMAIN' }),
        'carVal': new DBMappingInfo({ field: 'F_CARVAL', table: 'T_AOMMAIN' }),
        'cusVal': new DBMappingInfo({ field: 'F_CUSVAL', table: 'T_AOMMAIN' }),
        'carrierSpotNo': new DBMappingInfo({ field: 'F_CARRIERSPOTNO', table: 'T_AOMMAIN' }),
        'bCurr': new DBMappingInfo({ field: 'F_BCURR', table: 'T_AOMMAIN' }),
        'iataCurr': new DBMappingInfo({ field: 'F_IATACURR', table: 'T_AOMMAIN' }),
        'shipper': new DBMappingInfo({ field: 'F_SHIPPER', table: 'T_AOMMAIN' }),
        'agent': new DBMappingInfo({ field: 'F_AGENT', table: 'T_AOMMAIN' }),
        'carrier': new DBMappingInfo({ field: 'F_CARRIER', table: 'T_AOMMAIN' }),
        'lCode': new DBMappingInfo({ field: 'F_LCODE', table: 'T_AOMMAIN' }),
        'dCode': new DBMappingInfo({ field: 'F_DCODE', table: 'T_AOMMAIN' }),
        'to1': new DBMappingInfo({ field: 'F_TO1', table: 'T_AOMMAIN' }),
        'to2': new DBMappingInfo({ field: 'F_TO2', table: 'T_AOMMAIN' }),
        'loadingPort': new DBMappingInfo({ field: 'F_LOADINGPORT', table: 'T_AOMMAIN' }),
        'discharge': new DBMappingInfo({ field: 'F_DISCHARGE', table: 'T_AOMMAIN' }),
        'etd': new DBMappingInfo({ field: 'F_ETD', table: 'T_AOMMAIN' }),
        'eta': new DBMappingInfo({ field: 'F_ETA', table: 'T_AOMMAIN' }),
        'blDate': new DBMappingInfo({ field: 'F_BLDATE', table: 'T_AOMMAIN' }),
        'postDate': new DBMappingInfo({ field: 'F_POSTDATE', table: 'T_AOMMAIN' }),
        'blType': new DBMappingInfo({ field: 'F_BLTYPE', table: 'T_AOMMAIN' }),
        'ppCc': new DBMappingInfo({ field: 'F_PPCC', table: 'T_AOMMAIN' }),
        'bKl': new DBMappingInfo({ field: 'F_BKL', table: 'T_AOMMAIN' }),
        'iataKl': new DBMappingInfo({ field: 'F_IATAKL', table: 'T_AOMMAIN' }),
        'kl': new DBMappingInfo({ field: 'F_KL', table: 'T_AOMMAIN' }),
        'pkgs': new DBMappingInfo({ field: 'F_PKGS', table: 'T_AOMMAIN' }),
        'grossWeight': new DBMappingInfo({ field: 'F_GROSSWEIGHT', table: 'T_AOMMAIN' }),
        'lGrossWeight': new DBMappingInfo({ field: 'F_LGROSSWEIGHT', table: 'T_AOMMAIN' }),
        'chgWeight': new DBMappingInfo({ field: 'F_CHGWEIGHT', table: 'T_AOMMAIN' }),
        'lChgWeight': new DBMappingInfo({ field: 'F_LCHGWEIGHT', table: 'T_AOMMAIN' }),
        'iAmount': new DBMappingInfo({ field: 'F_IAMOUNT', table: 'T_AOMMAIN' }),
        'bRate': new DBMappingInfo({ field: 'F_BRATE', table: 'T_AOMMAIN' }),
        'bAmount': new DBMappingInfo({ field: 'F_BAMOUNT', table: 'T_AOMMAIN' }),
        'iataRate': new DBMappingInfo({ field: 'F_IATARATE', table: 'T_AOMMAIN' }),
        'iataAmount': new DBMappingInfo({ field: 'F_IATAAMOUNT', table: 'T_AOMMAIN' }),
        'fileClosed': new DBMappingInfo({ field: 'F_FILECLOSED', table: 'T_AOMMAIN' }),
        'closedBy': new DBMappingInfo({ field: 'F_CLOSEDBY', table: 'T_AOMMAIN' }),
        'handInfo': new DBMappingInfo({ field: 'F_HANDINFO', table: 'T_AOMMAIN' }),
        'accountInfo': new DBMappingInfo({ field: 'F_ACCOUNTINFO', table: 'T_AOMMAIN' }),
        'mark': new DBMappingInfo({ field: 'F_MARK', table: 'T_AOMMAIN' }),
        'description': new DBMappingInfo({ field: 'F_DESCRIPTION', table: 'T_AOMMAIN' }),
        'otherInfo': new DBMappingInfo({ field: 'F_OTHERINFO', table: 'T_AOMMAIN' }),
        'pWtChg': new DBMappingInfo({ field: 'F_PWTCHG', table: 'T_AOMMAIN' }),
        'cWtChg': new DBMappingInfo({ field: 'F_CWTCHG', table: 'T_AOMMAIN' }),
        'pValChg': new DBMappingInfo({ field: 'F_PVALCHG', table: 'T_AOMMAIN' }),
        'cValChg': new DBMappingInfo({ field: 'F_CVALCHG', table: 'T_AOMMAIN' }),
        'pTaxChg': new DBMappingInfo({ field: 'F_PTAXCHG', table: 'T_AOMMAIN' }),
        'cTaxChg': new DBMappingInfo({ field: 'F_CTAXCHG', table: 'T_AOMMAIN' }),
        'pAgtChg': new DBMappingInfo({ field: 'F_PAGTCHG', table: 'T_AOMMAIN' }),
        'cAgtChg': new DBMappingInfo({ field: 'F_CAGTCHG', table: 'T_AOMMAIN' }),
        'pCarChg': new DBMappingInfo({ field: 'F_PCARCHG', table: 'T_AOMMAIN' }),
        'cCarChg': new DBMappingInfo({ field: 'F_CCARCHG', table: 'T_AOMMAIN' }),
        'pTotal': new DBMappingInfo({ field: 'F_PTOTAL', table: 'T_AOMMAIN' }),
        'cTotal': new DBMappingInfo({ field: 'F_CTOTAL', table: 'T_AOMMAIN' }),
        'issuingCarrier': new DBMappingInfo({ field: 'F_ISSUINGCARRIER', table: 'T_AOMMAIN' }),
        'branch': new DBMappingInfo({ field: 'F_BRANCH', table: 'T_AOMMAIN' }),
        'rateClass': new DBMappingInfo({ field: 'F_RATECLASS', table: 'T_AOMMAIN' }),
        'cutOff': new DBMappingInfo({ field: 'F_CUTOFF', table: 'T_AOMMAIN' }),
        'cur1': new DBMappingInfo({ field: 'F_CUR1', table: 'T_AOMMAIN' }),
        'cur2': new DBMappingInfo({ field: 'F_CUR2', table: 'T_AOMMAIN' }),
        'exRate1': new DBMappingInfo({ field: 'F_EXRATE1', table: 'T_AOMMAIN' }),
        'exRate2': new DBMappingInfo({ field: 'F_EXRATE2', table: 'T_AOMMAIN' }),
        'completeBill': new DBMappingInfo({ field: 'F_COMPLETEBILL', table: 'T_AOMMAIN' }),
        'completeInvo': new DBMappingInfo({ field: 'F_COMPLETEINVO', table: 'T_AOMMAIN' }),
        'completeCrDb': new DBMappingInfo({ field: 'F_COMPLETECRDB', table: 'T_AOMMAIN' }),
        'profitShare': new DBMappingInfo({ field: 'F_PROFITSHARE', table: 'T_AOMMAIN' }),
        'line': new DBMappingInfo({ field: 'F_LINE', table: 'T_AOMMAIN' }),
        'shipmentType': new DBMappingInfo({ field: 'F_SHIPMENTTYPE', table: 'T_AOMMAIN' }),
        'agent2': new DBMappingInfo({ field: 'F_AGENT2', table: 'T_AOMMAIN' }),
        'agent3': new DBMappingInfo({ field: 'F_AGENT3', table: 'T_AOMMAIN' }),
        'mSmanId': new DBMappingInfo({ field: 'F_MSMANID', table: 'T_AOMMAIN' }),
        'operator': new DBMappingInfo({ field: 'F_Operator', table: 'T_AOMMAIN' }),
        'payableTo': new DBMappingInfo({ field: 'F_PAYABLETO', table: 'T_AOMMAIN' }),
        'dutyCustomer': new DBMappingInfo({ field: 'F_DUTYCUSTOMER', table: 'T_AOMMAIN' }),
        'dutyAgent': new DBMappingInfo({ field: 'F_DUTYAGENT', table: 'T_AOMMAIN' }),
        'mblCustomer': new DBMappingInfo({ field: 'F_MBLCUSTOMER', table: 'T_AOMMAIN' }),
        'u1Id': new DBMappingInfo({ field: 'F_U1ID', table: 'T_AOMMAIN' }),
        'u1Date': new DBMappingInfo({ field: 'F_U1Date', table: 'T_AOMMAIN' }),
        'u2Id': new DBMappingInfo({ field: 'F_U2ID', table: 'T_AOMMAIN' }),
        'u2Date': new DBMappingInfo({ field: 'F_U2Date', table: 'T_AOMMAIN' }),
        'agentRefNo': new DBMappingInfo({ field: 'AgentRefNo', table: 'T_AOMMAIN' }),
        'volCm': new DBMappingInfo({ field: 'VolCm', table: 'T_AOMMAIN' }),
        'mblCustomer2': new DBMappingInfo({ field: 'MblCustomer2', table: 'T_AOMMAIN' }),
        'projectNo': new DBMappingInfo({ field: 'ProjectNo', table: 'T_AOMMAIN' }),
        'labelRemark': new DBMappingInfo({ field: 'F_LabelRemark', table: 'T_AOMMAIN' }),
        'showCharged': new DBMappingInfo({ field: 'F_SHOWCHARGE', table: 'T_AOMMAIN' }),
        'showOther': new DBMappingInfo({ field: 'F_SHOWOTHER', table: 'T_AOMMAIN' }),
        'showOtherAmt': new DBMappingInfo({ field: 'F_SHOWOTHERAMT', table: 'T_AOMMAIN' }),
        'showToBy': new DBMappingInfo({ field: 'F_SHOWTOBY', table: 'T_AOMMAIN' }),
        
        //airline status
        'pickupDate': new DBMappingInfo({ field: 'f_pickupdate', table: 'T_AOMMAIN' }),
        'pickupLoc': new DBMappingInfo({ field: 'f_pickuploc', table: 'T_AOMMAIN' }),
        'atd': new DBMappingInfo({ field: 'f_atd', table: 'T_AOMMAIN' }),
        'atdLoc': new DBMappingInfo({ field: 'f_atdloc', table: 'T_AOMMAIN' }),
        'customsRls': new DBMappingInfo({ field: 'f_CustomRls', table: 'T_AOMMAIN' }),
        'customsRlsLoc': new DBMappingInfo({ field: 'f_custmrlsloc', table: 'T_AOMMAIN' }),
        'ata': new DBMappingInfo({ field: 'f_ata', table: 'T_AOMMAIN' }),
        'ataLoc': new DBMappingInfo({ field: 'f_ataloc', table: 'T_AOMMAIN' }),
        'avail': new DBMappingInfo({ field: 'f_avail', table: 'T_AOMMAIN' }),
        'availLoc': new DBMappingInfo({ field: 'f_availloc', table: 'T_AOMMAIN' }),
        'delivery': new DBMappingInfo({ field: 'f_delivery', table: 'T_AOMMAIN' }),
        'delvLoc': new DBMappingInfo({ field: 'f_delvloc', table: 'T_AOMMAIN' }),

        'showCharge': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'pUnit': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'firstTo': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'sAddr': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'cAddr': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'nAddr': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'nAddr2': new DBMappingInfo({ field: 'F_C8', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'sci': new DBMappingInfo({ field: 'F_C7', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'notify': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'notify2': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'chkEdit': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'consignee': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'etd1': new DBMappingInfo({ field: 'F_D1', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'etd2': new DBMappingInfo({ field: 'F_D2', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 2 }),
        'isDomestic': new DBMappingInfo({field: 'F_N6', table:'T_AOTHERINFO', tbName:'T_AOMMAIN', tbId: '@TBID', type: 2}),

    };

    hasNewEvents(): boolean {
        return this.toggledEvents.length > 0;
    }

    setChildTrackable(value: boolean): void {
        if(this.invList.length > 0) {
            this.invList.forEach(c => c.trackable = value);
        }
        if(this.descList.length > 0) {
            this.descList.forEach(c => c.trackable = value);
        }

        if(this.aeAcctData) this.aeAcctData.trackable = value;
    }
}
